import {STATUS_REDUCER_STATE_ID} from './status_constants';
import {statusSlice} from './status_slice';
import {generateGUID} from 'src/js/common/utils';
import AppUtils from 'src/js/common/utils/app_utils';
import {DlError} from 'src/js/model/error';
import {AppThunk} from 'src/js/store';

export function addError(item, category: string = 'GENERAL'): AppThunk {
  return (dispatch) => {
    let error = item.error || item || {};
    if (!(error instanceof DlError)) {
      // create DlError if it is not already passed
      error = new DlError(
        error,
        generateGUID(),
        category,
        new Date().getTime()
      );
    }
    dispatch(statusSlice.actions.addError({item: error}));
  };
}

export function setNewVersion(response: string): AppThunk {
  return (dispatch, getState) => {
    const {lastAppVersion} = getState()[STATUS_REDUCER_STATE_ID];
    const currentAppVersion = AppUtils.getVersion(response);
    if (
      lastAppVersion &&
      lastAppVersion !== '' &&
      lastAppVersion !== currentAppVersion
    ) {
      dispatch(
        statusSlice.actions.setNewVersionAvailable({newVersionAvailable: true})
      );
    }

    return dispatch(
      statusSlice.actions.setLastAppVersion({lastAppVersion: currentAppVersion})
    );
  };
}

export function loadNewVersion(): AppThunk {
  return (dispatch) => {
    dispatch(
      statusSlice.actions.setNewVersionAvailable({newVersionAvailable: false})
    );
    // reload application to load new version
    window.location.reload();
  };
}
